// extracted by mini-css-extract-plugin
export default {"container":"Zedr5zUPoD","mobile-dropdown":"azOil+bpuD","mobileDropdown":"azOil+bpuD","mobileDropdownItem":"+Xb+Ea+fJ+","user-header":"v-vyi7I0yX","userHeader":"v-vyi7I0yX","user-icon":"WZ3lfWLh+k","userIcon":"WZ3lfWLh+k","user-message":"_8-XhyhersW","userMessage":"_8-XhyhersW","profile-picture-mobile":"a2uf2nrxHs","profilePictureMobile":"a2uf2nrxHs"};
    if(module.hot) {
      // 1653462686854
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  